import { Component, OnInit, Inject } from '@angular/core';
import {   MatDialogRef,   MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData{
  name: string;
  description: string;
}

@Component({
  selector: 'app-dialog-delete-instructor-point',
  templateUrl: './dialog-delete-instructor-point.component.html',
  styleUrls: ['./dialog-delete-instructor-point.component.scss']
})
export class DialogDeleteInstructorPointComponent implements OnInit {

  checked:boolean = false;

  constructor(public dialogRef: MatDialogRef<DialogDeleteInstructorPointComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  ngOnInit(): void {
    this.checked = false;
  }
}
